import React, { Component } from 'react'
import BasicPage from './basic-page'

class NoResultsFound extends Component {

  render() {

    let { title, content } = this.props

    return (
      <BasicPage title={title} content={content} />
    )
  }
}

export default NoResultsFound
